import { Logo } from "@/components/brand/Logo";
import { ThemeToggle } from "@/components/layout/AppShell";
import SiteFooter from "@/components/brand/SiteFooter";

export const OWNER = { name: "[Razão social ou nome do responsável — a preencher]", doc: "[CPF/CNPJ — a preencher]", city: "[Cidade/UF — a preencher]" };
export const UPDATED = "08/10/2026";

export default function LegalLayout({ title, testid, sections }) {
  return (
    <div className="min-h-screen flex flex-col" data-testid={testid}>
      <header className="max-w-6xl w-full mx-auto px-5 h-16 flex items-center"><Logo /><div className="ml-auto"><ThemeToggle /></div></header>
      <main className="max-w-3xl w-full mx-auto px-5 py-12 flex-1">
        <p className="eyebrow mb-3">Documento legal</p>
        <h1 className="text-4xl sm:text-5xl font-bold mb-2">{title}</h1>
        <p className="text-sm text-muted-foreground mb-10">Última atualização: {UPDATED}</p>
        <div className="space-y-8 text-sm leading-relaxed">
          {sections.map(([h, body]) => (
            <section key={h}><h2 className="text-base md:text-lg font-semibold mb-2">{h}</h2>
              {[].concat(body).map((p, i) => <p key={i} className="text-muted-foreground mb-2">{p}</p>)}</section>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
